//
// Copyright (c) 2019-Present Syncari - All rights reserved.
//
const ActionTypeConstants = {
  LOGIN: 'LOGIN',
  LOGIN_FULFILLED: 'LOGIN_FULFILLED',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGIN_PENDING: 'LOGIN_PENDING',

  LOGOUT: 'LOGOUT',
  LOGOUT_FULFILLED: 'LOGOUT_FULFILLED',

  GET_CSRF_FULFILLED: 'GET_CSRF_FULFILLED',
  GET_CSRF_FAILED: 'GET_CSRF_FAILED',

  GET_VERSION: 'GET_VERSION',
  GET_VERSION_FULFILLED: 'GET_VERSION_FULFILLED',

  SHOW_ABOUT_PAGE: 'SHOW_ABOUT_PAGE',
} as const;

export default ActionTypeConstants;
